/**
 * Datas, na tela.
 *
 * Ao lado de `price-format.ts` e pelo mesmo motivo: dinheiro já tinha um lugar
 * só, data não tinha — `new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short' })`
 * estava copiado em CINCO arquivos, byte a byte igual, e o sexto ia nascer
 * igual (F096).
 *
 * Aceita a string ISO que vem da API ou um `Date` já pronto, porque as duas
 * coisas aparecem: um contrato entrega `dueAt` como texto, e um formulário
 * calcula a parcela como `Date` antes de mandar. Converter na chamada era o
 * `new Date(...)` que se repetia em todo lugar que usava o formatador.
 *
 * O que NÃO está aqui: os outros três formatos de data do app (data com hora,
 * dia da semana por extenso, hora num fuso escolhido). Cada um tem um único
 * usuário e uma razão própria — juntá-los aqui seria inventar um formatador
 * genérico com opções, que é a duplicação de volta com um nome melhor.
 */

const shortDate = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short' })

/** `28/08/2026`. */
export const formatDate = (value: string | Date): string =>
  shortDate.format(typeof value === 'string' ? new Date(value) : value)

/**
 * `2026-10-10` — o dia LOCAL de um instante, para um `<input type="date">`
 * (F248).
 *
 * `iso.slice(0, 10)` lê o dia em UTC: a previsão da compra, gravada às 23:59
 * de Brasília (02:59 do dia seguinte em UTC), voltava ao campo como o dia
 * seguinte — e cada vez que o rascunho era salvo, a previsão andava um dia.
 */
export const localDateInput = (iso: string): string => {
  const at = new Date(iso)
  const pad = (value: number): string => String(value).padStart(2, '0')
  return `${String(at.getFullYear())}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}`
}

const dayAndTime = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
})

/**
 * `07/10 14:32` — o dia e a hora, sem o ano e sem os segundos (F248).
 *
 * É o que cabe numa coluna e o que o balcão lê: "chegou hoje às 14:32". Era
 * escrito à mão em cada tela — `toLocaleString` com os segundos numa, sem a
 * hora noutra, com o ano numa terceira.
 */
export const formatDayTime = (value: string | Date): string =>
  dayAndTime.format(typeof value === 'string' ? new Date(value) : value)
